import { render, staticRenderFns } from "./OrganisationMembershipCard.vue?vue&type=template&id=8e4ea01c&scoped=true&"
import script from "./OrganisationMembershipCard.vue?vue&type=script&lang=js&"
export * from "./OrganisationMembershipCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ea01c",
  null
  
)

export default component.exports